import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="auth-shell">
      <div className="auth-panel">
        <div className="auth-brand">Kingfisher</div>
        <h1>Page Not Found</h1>
        <p className="auth-subtitle">The route does not exist in the static app.</p>
        <div className="auth-footer"><Link to="/">Go home</Link></div>
      </div>
    </div>
  );
}
